export type Breakpoint = 'xsmall' | 'mobile' | 'tablet' | 'desktop';

export enum BreakpointEnum {
  XSmall = 'xsmall',
  Mobile = 'mobile',
  Tablet = 'tablet',
  Desktop = 'desktop',
}

export function getBreakpoint(width: number = window.innerWidth): Breakpoint {
  if (width < 480) return 'xsmall'; // very small devices/400% zoom
  if (width < 576) return 'mobile'; // standard mobile design
  if (width < 1200) return 'tablet';
  return 'desktop';
}

import { useState, useEffect } from 'react';

export function useBreakpoint(): Breakpoint {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(() => getBreakpoint());

  useEffect(() => {
    const handleResize = () => setBreakpoint(getBreakpoint());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return breakpoint;
}
